'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:NotFoundCtrl
 * @description
 * # NotFoundCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('NotFoundCtrl', function () {
    this.awesomeThings = [
      'HTML5 Boilerplate',
      'AngularJS',
      'Karma'
    ];
  });
